/**
 * BUY NOW: (1) a second tap is ignored until the first add to cart has finished; (2) after ONE unit was added, follow the
 * theme setting: go to /checkout ("checkout", default) or open Horizon's cart drawer ("drawer").
 * Horizon does not disable the button while the request runs, and its own handler ignores a submit while any button is
 * disabled, so the buttons are disabled AFTER it dispatches its cart event and re-enabled when that event's promise
 * settles (response or error). A failed add shows Horizon's error text in the form and stays on the page.
 */
import { StandardEvents } from '@shopify/events';

const busy = new WeakSet();
const drawer = () => document.querySelector('theme-drawer#cart-drawer');
const mode = (form) => (form.dataset.hunaBuy === 'drawer' ? 'drawer' : 'checkout');

// Checkout mode must not flash the drawer open before the redirect.
if (document.querySelector('product-form-component[data-huna-buy="checkout"]')) {
  document.querySelector('cart-drawer-component')?.removeAttribute('auto-open');
}
addEventListener('pageshow', (e) => e.persisted && location.reload()); // back button after checkout: fresh state

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  if (!form || !event.promise || busy.has(form)) return;

  busy.add(form);
  // Only buttons that were usable are re-enabled (a sold-out button stays disabled).
  const buttons = [...form.querySelectorAll('add-to-cart-component')].map((c) => c.refs?.addToCartButton).filter((b) => b && !b.disabled);
  buttons.forEach((b) => {
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
  });

  const done = () => {
    if (!busy.delete(form)) return;
    buttons.forEach((b) => {
      b.disabled = false;
      b.removeAttribute('aria-busy');
    });
  };
  event.promise.then(
    (result) => {
      if (result?.detail?.didError) return done();
      if (mode(form) === 'checkout') return location.assign('/checkout'); // buttons stay disabled while navigating
      done();
      const d = drawer();
      if (d && !d.isOpen) d.open();
    },
    done
  );
  setTimeout(done, 15000); // safety net if a response never arrives
});
